import {Injectable} from '@angular/core';
import {PostLoginLoanApplicationFlowStep} from './post-login-loan-application-flow.step';
import {UserInteractor} from '../../interactors/user.interactor';
import {BankAccountInteractor} from "../../interactors/bank-account.interactor";
import {LoanApplicationInteractor} from "../../interactors/loan-application.interactor";
import {isEmpty} from 'lodash';

@Injectable()
export class BankDetailStep extends PostLoginLoanApplicationFlowStep {
    constructor(userInteractor: UserInteractor, private bankAccountInteractor: BankAccountInteractor, private loanApplicationInteractor: LoanApplicationInteractor) {
        super(userInteractor);
    }

    description(): string {
        return 'To disburse your loan amount';
    }

    displayName(): string {
        return 'Bank Details';
    }

    async isStepComplete(): Promise<boolean> {
        const loanApplication = await this.loanApplicationInteractor.get();
        return !isEmpty(loanApplication && loanApplication.bankAccountId) &&
            !isEmpty(await this.bankAccountInteractor.get(loanApplication.bankAccountId));
    }

    url(): string {
        return this.createBorrowerFlowUrl('bank-details');
    }
}
